var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBloxEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 178,
    height: 189,
    viewBox: "0 0 178 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M82.952 7l64.952 37.5v75L82.952 157 18 119.5v-75z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 129.904,
    height: 150,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#A2A2A2",
    strokeDasharray: 2,
    strokeWidth: 2,
    mask: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.5,
    cy: 186,
    fill: "#E4E4E4",
    rx: 27.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 25.5,
    r: 2.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 3,
    r: 3,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6,
    r: 2,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 61.5,
    r: 2.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 9.5,
    r: 2.5,
    fill: "#D8D8D8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloxEmptyState);
export default __webpack_public_path__ + "static/media/blox-empty-state.398811859ae67beba4df901a85884cf0.svg";
export { ForwardRef as ReactComponent };